export const BASE_URL = 'https://coast-camping-backend.onrender.com/api/v1'; // Example
